import { Component, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { TuiButton, TuiGroup } from '@taiga-ui/core';
import { TuiHeader } from '@taiga-ui/layout';
import { AuthService } from '../services/auth.service';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [TuiHeader, TuiGroup, TuiButton, RouterLink],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  logOut() {
    this.authService.logout().subscribe();
    this.authService.token = null;
    localStorage.removeItem('token');
    this.router.navigate(['/login']);
  }
}
